(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["all-products-infinite"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('items-infinite-products')) {
    class ItemsInfiniteProducts extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-items-infinite-grid]');
        this.status = this.querySelector('[data-items-infinite-status]');
        this.sentinel = this.querySelector('[data-items-infinite-sentinel]');
        this.fallback = this.querySelector('[data-items-infinite-fallback]');
        this.nextUrl = this.dataset.nextUrl;
        this.loading = false;
        this.autoPaused = false;
        this.loadNext = this.loadNext.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleFallbackClick = this.handleFallbackClick.bind(this);

        if (this.fallback) {
          this.fallback.hidden = true;
          this.fallback.addEventListener('click', this.handleFallbackClick);
        }

        if ('IntersectionObserver' in window && this.nextUrl && this.sentinel) {
          this.observer = new IntersectionObserver(
            (entries) => {
              if (entries[0].isIntersecting) this.loadNext();
            },
            { rootMargin: '600px 0px' }
          );
          this.observer.observe(this.sentinel);
        } else if (this.nextUrl) {
          window.addEventListener('scroll', this.handleScroll, { passive: true });
          this.handleScroll();
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        window.removeEventListener('scroll', this.handleScroll);
        this.fallback?.removeEventListener('click', this.handleFallbackClick);
      }

      handleScroll() {
        if (this.sentinel?.getBoundingClientRect().top < window.innerHeight + 600) this.loadNext();
      }

      handleFallbackClick(event) {
        event.preventDefault();
        this.autoPaused = false;
        this.fallback.hidden = true;
        this.loadNext();
      }

      async loadNext() {
        if (this.loading || !this.nextUrl || this.autoPaused) return;
        this.loading = true;
        this.setAttribute('data-loading', '');
        this.setAttribute('aria-busy', 'true');
        this.status.textContent = this.dataset.loadingText;
        if (this.fallback) this.fallback.hidden = true;

        try {
          const url = new URL(this.nextUrl, window.location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });

          if (!response.ok) throw new Error(String(response.status));

          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const nextSection = documentFragment.querySelector('items-infinite-products');

          if (!nextSection) throw new Error('missing-section');

          const nextItems = nextSection.querySelectorAll('[data-items-infinite-grid] > .grid__item');
          const fragment = document.createDocumentFragment();
          nextItems.forEach((item) => fragment.appendChild(item));
          this.grid.appendChild(fragment);

          this.nextUrl = nextSection.dataset.nextUrl || '';
          this.dataset.nextUrl = this.nextUrl;
          this.status.textContent = this.nextUrl ? this.dataset.loadedText : this.dataset.completeText;

          if (this.fallback && this.nextUrl) {
            this.fallback.href = this.nextUrl;
          }

          if (!this.nextUrl) {
            this.observer?.disconnect();
            window.removeEventListener('scroll', this.handleScroll);
            this.fallback?.remove();
          }
        } catch (error) {
          this.autoPaused = true;
          this.status.textContent = this.dataset.errorText;
          if (this.fallback) {
            this.fallback.href = this.nextUrl;
            this.fallback.hidden = false;
          }
        } finally {
          this.loading = false;
          this.removeAttribute('data-loading');
          this.setAttribute('aria-busy', 'false');
        }
      }
    }

    customElements.define('items-infinite-products', ItemsInfiniteProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-product-discovery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('items-cart-discovery-summary')) {
    class ItemsCartDiscoverySummary extends HTMLElement {
      connectedCallback() {
        this.goalCents = Number.parseInt(this.dataset.goalCents, 10) || 20000000;
        this.feedSection = this.closest('.shopify-section');
        this.heading = this.feedSection?.querySelector('[data-discovery-heading]');
        this.totalOutput = this.querySelector('[data-cart-discovery-total]');
        this.remainingOutput = this.querySelector('[data-cart-discovery-remaining]');
        this.topButton = this.querySelector('[data-cart-discovery-top]');
        this.handleBackToTop = this.handleBackToTop.bind(this);
        this.cancelReturnFocus = () => {
          this.returnFocus = false;
        };
        this.topButton?.addEventListener('click', this.handleBackToTop);
        ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach((eventName) => {
          window.addEventListener(eventName, this.cancelReturnFocus, { passive: true });
        });
        this.handlePosition = this.handlePosition.bind(this);
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (Number.isFinite(event.cartData?.total_price) && Number.isFinite(event.cartData?.item_count)) {
            this.update(event.cartData);
          } else {
            this.refresh();
          }
        });
        window.addEventListener('scroll', this.handlePosition, { passive: true });
        window.addEventListener('resize', this.handlePosition, { passive: true });
        this.update({
          total_price: Number.parseInt(this.dataset.initialTotal, 10) || 0,
          item_count: Number.parseInt(this.dataset.initialCount, 10) || 0,
        });
      }

      disconnectedCallback() {
        this.cartUpdateUnsubscriber?.();
        window.removeEventListener('scroll', this.handlePosition);
        window.removeEventListener('resize', this.handlePosition);
        this.topButton?.removeEventListener('click', this.handleBackToTop);
        ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach((eventName) => {
          window.removeEventListener(eventName, this.cancelReturnFocus);
        });
      }

      handleBackToTop() {
        this.returnFocus = true;
        window.scrollTo({
          top: 0,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
        });
        this.handlePosition();
      }

      formatMoney(cents) {
        return new Intl.NumberFormat('es-AR', {
          style: 'currency',
          currency: 'ARS',
          maximumFractionDigits: 0,
        }).format(cents / 100);
      }

      update(cart) {
        const total = cart.total_price || 0;
        const count = cart.item_count || 0;
        this.dataset.initialTotal = String(total);
        this.dataset.initialCount = String(count);
        this.hidden = false;
        const wasEmpty = this.classList.contains('is-empty');
        this.classList.toggle('is-empty', count === 0);
        const checkoutButton = this.querySelector('[name="checkout"]');
        if (checkoutButton && (count === 0 || wasEmpty)) checkoutButton.disabled = count === 0;

        if (this.heading) {
          const heading = count === 0 ? this.dataset.emptyHeading : this.dataset.fullHeading;
          if (heading) this.heading.textContent = heading;
        }

        if (this.totalOutput) {
          this.totalOutput.textContent = `${this.dataset.totalLabel}: ${this.formatMoney(total)}`;
        }

        if (this.remainingOutput) {
          this.remainingOutput.textContent =
            total >= this.goalCents
              ? this.dataset.completeLabel
              : `${this.dataset.remainingLabel} ${this.formatMoney(this.goalCents - total)}`;
        }

        this.handlePosition();
      }

      refresh() {
        fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
          .then((response) => response.json())
          .then((cart) => this.update(cart))
          .catch(() => {});
      }

      handlePosition() {
        if (this.returnFocus && window.scrollY <= 2) {
          this.returnFocus = false;
          document.querySelector('.header__heading-link')?.focus({ preventScroll: true });
        }

        if (this.hidden || !this.feedSection) {
          this.classList.remove('is-floating');
          return;
        }

        const checkout = document.getElementById('checkout');
        const feedBounds = this.feedSection.getBoundingClientRect();
        const checkoutPassed = this.classList.contains('is-empty')
          ? window.scrollY >= 480
          : checkout && checkout.getBoundingClientRect().bottom < 0;
        const feedVisible = feedBounds.top < window.innerHeight && feedBounds.bottom > 0;
        this.classList.toggle('is-floating', Boolean(checkoutPassed && feedVisible));
      }
    }

    customElements.define('items-cart-discovery-summary', ItemsCartDiscoverySummary);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["items-home-catalog"] && !Shopify.designMode) return;
  try {
    
(function (scope) {
  'use strict';

  const BEST = 'best-selling';
  const INGRESS = 'manual';
  const PAGE_SIZE = 18;
  const FIRST_PASS_SIZE = 180;
  const cursor = () => ({ page: 1, index: 0, done: false });
  const productId = (item) => {
    if (!item || !['string', 'number'].includes(typeof item.id) || String(item.id).trim() === '') {
      throw new TypeError('Catalog products require a nonempty string or number id.');
    }
    return String(item.id);
  };

  class ItemsCatalogSequenceV9 {
    constructor({ getPage }) {
      if (typeof getPage !== 'function') throw new TypeError('getPage must be a function.');
      this.getPage = getPage;
      this.pages = new Map();
      this.pending = null;
      this.state = {
        seen: new Set(),
        ranked: { [BEST]: cursor(), [INGRESS]: cursor() },
        unseen: cursor(),
        mixedStarted: false,
        batches: 0,
        done: false
      };
    }

    snapshot() {
      return {
        uniqueCount: this.state.seen.size,
        batches: this.state.batches,
        done: this.state.done,
        mixedStarted: this.state.mixedStarted,
        ranked: {
          [BEST]: { ...this.state.ranked[BEST] },
          [INGRESS]: { ...this.state.ranked[INGRESS] }
        },
        unseen: { ...this.state.unseen }
      };
    }

    nextBatch() {
      if (this.pending) return this.pending;
      this.pending = this.buildBatch().finally(() => { this.pending = null; });
      return this.pending;
    }

    async page(sort, number) {
      const key = `${sort}:${number}`;
      if (!this.pages.has(key)) {
        const response = await this.getPage(sort, number);
        if (!response || !Array.isArray(response.items) || typeof response.next !== 'boolean') {
          throw new TypeError('getPage must return { items: [], next: boolean }.');
        }
        if (response.items.length > PAGE_SIZE || (!response.items.length && response.next)) {
          throw new RangeError('Catalog source pages must contain at most 18 items and advance.');
        }
        response.items.forEach(productId);
        this.pages.set(key, { items: response.items.slice(), next: response.next });
      }
      return this.pages.get(key);
    }

    async read(sort, position) {
      while (!position.done) {
        const page = await this.page(sort, position.page);
        if (position.index < page.items.length) {
          const item = page.items[position.index++];
          if (position.index === page.items.length && !page.next) position.done = true;
          return item;
        }
        if (!page.next) {
          position.done = true;
          return null;
        }
        position.page += 1;
        position.index = 0;
      }
      return null;
    }

    async take(sort, position, count, excluded, cycle = false) {
      const selected = [];
      let wrapped = false;
      while (selected.length < count) {
        const item = await this.read(sort, position);
        if (item === null) {
          if (!cycle || wrapped) break;
          Object.assign(position, cursor());
          wrapped = true;
          continue;
        }
        const id = productId(item);
        if (excluded.has(id)) continue;
        excluded.add(id);
        selected.push(item);
      }
      return selected;
    }

    async buildBatch() {
      const current = this.state;
      if (current.done) return this.result([], true, current.mixedStarted ? 'mixed' : 'alternating', [], current);
      const next = {
        seen: new Set(current.seen),
        ranked: { [BEST]: { ...current.ranked[BEST] }, [INGRESS]: { ...current.ranked[INGRESS] } },
        unseen: { ...current.unseen },
        mixedStarted: current.mixedStarted,
        batches: current.batches,
        done: current.done
      };
      let items;
      let groups;
      let phase;

      if (next.seen.size < FIRST_PASS_SIZE) {
        phase = 'alternating';
        const sort = next.batches % 2 === 0 ? BEST : INGRESS;
        items = await this.take(sort, next.ranked[sort], Math.min(PAGE_SIZE, FIRST_PASS_SIZE - next.seen.size), next.seen);
        groups = [{ source: sort, count: items.length }];
        next.done = next.ranked[sort].done;
      } else {
        phase = 'mixed';
        if (!next.mixedStarted) {
          next.ranked = { [BEST]: cursor(), [INGRESS]: cursor() };
          next.mixedStarted = true;
        }
        const unseen = await this.take(BEST, next.unseen, 6, new Set(next.seen));
        if (!unseen.length) {
          next.done = true;
          this.state = next;
          return this.result([], true, phase, [], next);
        }
        const batchIds = new Set(unseen.map(productId));
        const newest = await this.take(INGRESS, next.ranked[INGRESS], 6, batchIds, true);
        const best = await this.take(BEST, next.ranked[BEST], 6, batchIds, true);
        items = [...newest, ...best, ...unseen];
        groups = [
          { source: INGRESS, count: newest.length },
          { source: BEST, count: best.length },
          { source: 'unseen', count: unseen.length }
        ];
        items.forEach((item) => next.seen.add(productId(item)));
        next.done = next.unseen.done;
      }

      if (items.length) next.batches += 1;
      this.state = next;
      return this.result(items, next.done, phase, groups, next);
    }

    result(items, done, phase, groups, state) {
      return { items, done, phase, groups, batchIndex: state.batches, uniqueCount: state.seen.size };
    }
  }

  scope.ItemsCatalogSequenceV9 = ItemsCatalogSequenceV9;
})(globalThis);

  if (!customElements.get('items-home-catalog')) {
    customElements.define('items-home-catalog', class extends HTMLElement {
      async connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.generation = (this.generation || 0) + 1;
        this.grid = this.querySelector('[data-items-catalog-grid]');
        this.status = this.querySelector('[data-items-catalog-status]');
        this.more = this.querySelector('[data-items-catalog-more]');
        this.sentinel = this.querySelector('[data-items-catalog-sentinel]');
        this.loading = false;
        this.paused = false;
        this.controller = new AbortController();
        this.handleScroll = () => {
          if (this.sentinel.getBoundingClientRect().top < window.innerHeight + 400) this.loadNext();
        };
        this.more.addEventListener('click', () => {
          this.paused = false;
          this.loadNext();
        }, { signal: this.controller.signal });
        const generation = this.generation;
        await customElements.whenDefined('items-catalog-support');
        if (!this.isConnected || generation !== this.generation) return;
        this.sequence ||= new window.ItemsCatalogSequenceV9({
          getPage: (sort, page) => window.ItemsCatalogCards.fetchPage(this.dataset.sourceUrl, sort, page)
        });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) this.loadNext();
          }, { rootMargin: '400px 0px' });
          this.observer.observe(this.sentinel);
        } else {
          window.addEventListener('scroll', this.handleScroll, { passive: true, signal: this.controller.signal });
        }
        if (!this.grid.children.length) this.loadNext();
      }
      disconnectedCallback() {
        this.generation = (this.generation || 0) + 1;
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.checkFrame);
        this.initialized = false;
      }
      async loadNext() {
        if (this.loading || this.paused || !this.sequence || this.dataset.complete === 'true' || !this.isConnected) return;
        this.loading = true;
        const generation = this.generation;
        this.setAttribute('aria-busy', 'true');
        this.status.textContent = this.dataset.loadingText;
        this.more.hidden = true;
        try {
          const batch = this.pendingBatch || await this.sequence.nextBatch();
          this.pendingBatch = batch;
          if (!this.isConnected || generation !== this.generation) return;
          const fragment = document.createDocumentFragment();
          const prefix = this.closest('.shopify-section')?.id || 'items-catalog';
          batch.items.forEach((item, index) => {
            const card = window.ItemsCatalogCards.prepareCard(item, `${prefix}-batch-${batch.batchIndex}-${index}`);
            card.dataset.itemsBatch = String(batch.batchIndex);
            fragment.append(card);
          });
          this.grid.append(fragment);
          this.pendingBatch = null;
          window.ItemsCatalogCards.releaseClaims();
          this.dataset.batches = String(batch.batchIndex);
          this.dataset.uniqueCount = String(batch.uniqueCount);
          this.dataset.phase = batch.phase;
          this.status.textContent = batch.done ? this.dataset.completeText : '';
          this.dataset.complete = String(batch.done);
          this.dispatchEvent(new CustomEvent('items:catalog-batch', { detail: { count: batch.items.length, phase: batch.phase, groups: batch.groups, uniqueCount: batch.uniqueCount, batchIndex: batch.batchIndex }, bubbles: true }));
          if (batch.done) this.observer?.disconnect();
        } catch (error) {
          window.ItemsCatalogCards.releaseClaims();
          if (!this.isConnected || generation !== this.generation) return;
          this.paused = true;
          this.status.textContent = this.dataset.errorText;
          this.more.hidden = false;
        } finally {
          if (generation === this.generation) {
            this.loading = false;
            this.setAttribute('aria-busy', 'false');
            if (!this.paused && this.dataset.complete !== 'true') this.checkFrame = requestAnimationFrame(this.handleScroll);
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["items-home-motion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('items-home-motion')) {
    customElements.define('items-home-motion', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.generation = (this.generation || 0) + 1;
        this.viewport = this.querySelector('[data-items-sellers-viewport]');
        this.track = this.querySelector('[data-items-sellers-track]');
        this.abortController = new AbortController();
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.touching = false;
        this.touchContacts = 0;
        this.nativeScrolling = false;
        this.hovered = false;
        this.focused = false;
        this.visible = true;
        this.holdUntil = 0;
        this.fraction = 0;
        this.setupMarquee(this.generation);
        const options = { signal: this.abortController.signal };
        this.viewport.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') this.hovered = true;
        }, options);
        this.viewport.addEventListener('pointerleave', () => { this.hovered = false; }, options);
        this.viewport.addEventListener('focusin', () => { this.focused = true; }, options);
        this.viewport.addEventListener('focusout', event => { this.focused = this.viewport.contains(event.relatedTarget); }, options);
        const passiveOptions = { ...options, passive: true };
        const holdNativeScroll = () => {
          this.nativeScrolling = true;
          this.holdUntil = performance.now() + 2500;
          this.fraction = 0;
        };
        this.viewport.addEventListener('pointerdown', () => {
          this.touching = true;
          holdNativeScroll();
        }, options);
        const endPointer = event => {
          // A native pan cancels the touch pointer before the finger is lifted.
          if ((event.pointerType === 'touch' && this.touchContacts > 0) || !this.touching) return;
          this.touching = false;
          holdNativeScroll();
        };
        window.addEventListener('pointerup', endPointer, options);
        window.addEventListener('pointercancel', endPointer, options);
        this.viewport.addEventListener('touchstart', event => {
          this.touchContacts = event.touches.length;
          this.touching = true;
          holdNativeScroll();
        }, passiveOptions);
        const endTouch = event => {
          if (!this.touchContacts) return;
          this.touchContacts = event.touches.length;
          this.touching = this.touchContacts > 0;
          holdNativeScroll();
        };
        window.addEventListener('touchend', endTouch, passiveOptions);
        window.addEventListener('touchcancel', endTouch, passiveOptions);
        this.viewport.addEventListener('wheel', holdNativeScroll, passiveOptions);
        this.viewport.addEventListener('scroll', () => {
          if (this.nativeScrolling) this.holdUntil = performance.now() + 2500;
        }, passiveOptions);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; });
        this.observer.observe(this);
        if (this.dataset.loaded === 'true' && this.track.children.length) {
          this.recycle();
          this.lastTime = performance.now();
          this.animationFrame = requestAnimationFrame(time => this.tick(time));
        } else {
          this.loadCards(this.generation);
        }
      }
      disconnectedCallback() {
        this.generation = (this.generation || 0) + 1;
        this.abortController?.abort();
        this.observer?.disconnect();
        this.marqueeObserver?.disconnect();
        cancelAnimationFrame(this.marqueeFrame);
        cancelAnimationFrame(this.animationFrame);
        this.initialized = false;
      }
      setupMarquee(generation) {
        this.marquee = this.querySelector('.items-motion__marquee');
        this.ticker = this.querySelector('.items-motion__ticker');
        this.tickerPattern ||= this.ticker.firstElementChild.cloneNode(true);
        const schedule = () => {
          cancelAnimationFrame(this.marqueeFrame);
          this.marqueeFrame = requestAnimationFrame(() => {
            if (this.isConnected && generation === this.generation) this.fillMarquee();
          });
        };
        this.marqueeObserver = new ResizeObserver(schedule);
        this.marqueeObserver.observe(this.marquee);
        document.fonts.ready.then(schedule);
        this.fillMarquee();
      }
      fillMarquee() {
        const group = this.tickerPattern.cloneNode(true);
        this.ticker.replaceChildren(group);
        const unitWidth = group.getBoundingClientRect().width;
        if (!unitWidth) return;
        // Each half must cover the viewport throughout the complete animation cycle.
        const copies = Math.max(1, Math.ceil((this.marquee.clientWidth + 1) / unitWidth));
        for (let index = 1; index < copies; index++) {
          group.append(...Array.from(this.tickerPattern.children, child => child.cloneNode(true)));
        }
        this.ticker.append(group.cloneNode(true));
        const duration = parseFloat(getComputedStyle(this).getPropertyValue('--items-marquee-duration')) || 30;
        this.ticker.style.animationDuration = `${duration * copies}s`;
      }
      async loadCards(generation = this.generation) {
        try {
          await customElements.whenDefined('items-catalog-support');
          const page = await window.ItemsCatalogCards.fetchPage(this.dataset.sourceUrl, 'best-selling', 1);
          if (!this.isConnected || generation !== this.generation) return;
          const cards = page.items.slice(0, Number(this.dataset.productsLimit || 15));
          if (!cards.length) throw new Error('No products returned');
          const prefix = this.closest('.shopify-section')?.id || 'items-motion';
          cards.forEach((item, index) => {
            const card = window.ItemsCatalogCards.prepareCard(item, `${prefix}-carousel-${index}`);
            card.classList.remove('grid__item');
            card.classList.add('items-motion__card');
            this.track.append(card);
          });
          window.ItemsCatalogCards.releaseClaims();
          this.querySelector('[data-items-sellers-loading]').hidden = true;
          this.viewport.setAttribute('aria-busy', 'false');
          this.dataset.loaded = 'true';
          this.recycle();
          this.lastTime = performance.now();
          this.animationFrame = requestAnimationFrame(time => this.tick(time));
        } catch (error) {
          window.ItemsCatalogCards?.releaseClaims();
          if (error.name === 'AbortError' || !this.isConnected || generation !== this.generation) return;
          this.viewport.setAttribute('aria-busy', 'false');
          this.dataset.error = 'true';
          this.querySelector('[data-items-sellers-loading]').hidden = true;
          const link = document.createElement('a');
          link.className = 'items-motion__fallback';
          link.href = this.dataset.sourceUrl;
          link.textContent = this.viewport.getAttribute('aria-label');
          this.viewport.append(link);
        }
      }
      distance() {
        return this.track.firstElementChild?.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap || 0);
      }
      recycle() {
        const distance = this.distance();
        if (!distance) return;
        const available = this.viewport.scrollWidth - this.viewport.clientWidth;
        if (available < distance) return;
        // Keep two cards before the visible window so a reverse swipe has room.
        const buffer = Math.min(2, Math.max(0, Math.floor(available / distance) - 1)) * distance;
        let position = this.viewport.scrollLeft;
        let moved = false;
        let remaining = this.track.children.length;
        while (position >= buffer + distance && remaining-- > 0) {
          this.track.append(this.track.firstElementChild);
          position -= distance;
          moved = true;
        }
        remaining = this.track.children.length;
        while (position < buffer && remaining-- > 0) {
          this.track.prepend(this.track.lastElementChild);
          position += distance;
          moved = true;
        }
        if (moved) this.viewport.scrollLeft = position;
      }
      tick(time) {
        const delta = Math.min(time - this.lastTime, 64);
        this.lastTime = time;
        if (!this.touching && time > this.holdUntil) this.nativeScrolling = false;
        if (!this.reducedMotion.matches && !this.hovered && !this.focused && !this.touching && this.visible && !document.hidden && time > this.holdUntil) {
          this.fraction += delta * Number(this.dataset.speed || 50) / 1000;
          const pixels = Math.floor(this.fraction);
          if (pixels > 0) {
            this.fraction -= pixels;
            this.viewport.scrollLeft += pixels;
            this.recycle();
          }
        }
        this.animationFrame = requestAnimationFrame(nextTime => this.tick(nextTime));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
